// ------------------------------------------------------------
// 1) Po načtení DOM (HTML) inicializujeme animace a ScrollSmoother
// ------------------------------------------------------------
document.addEventListener("DOMContentLoaded", () => {
    // Registrace pluginů GSAP
    gsap.registerPlugin(ScrollTrigger, SplitText);



    // -------------- Dark Multiply --------------
    const textSection = document.querySelector(".dark-multiply");
    if (textSection) {
        // Primární barva z administrace (CSS proměnná nastavená v header.php)
        const dangerRgb = getComputedStyle(document.documentElement).getPropertyValue('--bs-danger-rgb').trim() || '240, 83, 88';
        gsap.from(".word-wall-word", {
            opacity: 0,
            textShadow: `0 0 20px rgba(${dangerRgb}, 0.8)`,
            scale: 1.2,
            duration: 0.6,
            ease: "power2.out",
            stagger: {
                amount: 2,
                from: "random"
            },
            scrollTrigger: {
                trigger: ".dark-multiply",
                start: "top 80%",
                toggleActions: "play none none reverse"
            }
        });
    }

    // -------------- Navbar background on scroll --------------
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        const toggleNavbarBackground = () => {
            if (window.scrollY > 0) {
                navbar.classList.add('scrolled');
            } else {
                navbar.classList.remove('scrolled');
            }
        };
        window.addEventListener('scroll', toggleNavbarBackground);
        toggleNavbarBackground();
    }
});

